import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

import { StatusTextComponent } from './status-text.component';

export const imports = [CommonModule, FlexLayoutModule, TranslateModule];

export const declarations = [StatusTextComponent];

@NgModule({
  declarations,
  exports: [StatusTextComponent],
  imports,
  providers: [],
})
export class StatusTextModule {}
